import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uzCommon from './locales/uz/common.json';
import uzOwner from './locales/uz/owner.json';
import uzCustomer from './locales/uz/customer.json';
import uzProvider from './locales/uz/provider.json';
import uzErrors from './locales/uz/errors.json';

import ruCommon from './locales/ru/common.json';
import ruOwner from './locales/ru/owner.json';
import ruCustomer from './locales/ru/customer.json';
import ruProvider from './locales/ru/provider.json';
import ruErrors from './locales/ru/errors.json';

import enCommon from './locales/en/common.json';
import enOwner from './locales/en/owner.json';
import enCustomer from './locales/en/customer.json';
import enProvider from './locales/en/provider.json';
import enErrors from './locales/en/errors.json';

void i18n.use(initReactI18next).init({
  resources: {
    uz: {
      common: uzCommon,
      owner: uzOwner,
      customer: uzCustomer,
      provider: uzProvider,
      errors: uzErrors,
    },
    ru: {
      common: ruCommon,
      owner: ruOwner,
      customer: ruCustomer,
      provider: ruProvider,
      errors: ruErrors,
    },
    en: {
      common: enCommon,
      owner: enOwner,
      customer: enCustomer,
      provider: enProvider,
      errors: enErrors,
    },
  },
  lng: 'uz',
  fallbackLng: 'uz',
  defaultNS: 'common',
  ns: ['common', 'owner', 'customer', 'provider', 'errors'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
